import { Component, Input, OnChanges, OnInit } from "@angular/core";
import {
    StepStateEnum,
    WorkflowStepConfig,
} from "../common/eff-workflow-bar/models/workflow-step-config";
import { EffStepStatus, EffWorkFlowState } from "../common/services/eff-workflow.service";
import { EffWorkflowBarComponent } from "../common/eff-workflow-bar/eff-workflow-bar.component";

@Component({
    selector: "eff-workflow-status",
    templateUrl: "./eff-workflow-status.component.html",
    styleUrls: ["./eff-workflow-status.component.scss"],
    imports: [EffWorkflowBarComponent]
})
export class EffWorkflowStatusComponent implements OnInit, OnChanges {
    @Input() workFlowSteps: EffWorkFlowState[] = [];
    stepsConfigs: WorkflowStepConfig[] = [];

    ngOnInit() {
        this.initSteps();
    }

    ngOnChanges(): void {
        this.initSteps();
    }

    initSteps() {
        this.stepsConfigs = [];
        if (this.workFlowSteps && this.workFlowSteps.length > 0) {
            this.workFlowSteps.forEach((step) => {
                this.stepsConfigs.push({
                    Id: step.stepId,
                    NameKey: step.nameKey,
                    State: this.getState(step),
                    CompletedBy: step.completedBy,
                    CompletedOn: step.completedOn,
                    DueDate: step.dueDate,
                    AssignedUsers: step.assignedUsers,
                });
            });
        }
    }

    getState(step: EffWorkFlowState) {
        switch (step.status) {
            case EffStepStatus.Completed:
                return StepStateEnum.Completed;
            case EffStepStatus.InProgress:
            case EffStepStatus.ReadyToStart:
                return StepStateEnum.Active;
        }

        return StepStateEnum.Disabled;
    }
}
